import {useEffect} from 'react';
import * as store from '@/store';
import debounce from 'lodash-es/debounce';
import eventBus, {EDITOR_DOM_READY} from '@/eventBus';

/**
 * 管理文档空状态信息
 * @param docGuid 文档guid
 * @param resetData 组件销毁后是否重置状态，默认false
 */
export const useCheckDocEmpty = (docGuid: string, mode: string) => {
    /**
     * 延迟check并同步文档空状态信息
     */
    const syncIsDocEmptyDebounce = debounce(() => {
        const editorRef = store.getEditorRef();
        let isDocEmpty = editorRef.current?.isEmptyDocument();
        let isDocEmptyWithSpace = editorRef.current?.isEmptyDocument({includeSpace: true});
        console.info('======>check docIsEmpty:', isDocEmpty); // 调试信息
        console.info('======>check docIsEmptyWithSpace:', isDocEmptyWithSpace); // 调试信息

        // 业务耦合场景：isDocEmpty为true时，需要排除AI创作重新生成时，先将文档内容清空再接着生成数据的场景（文档也会获得空状态）
        if (isDocEmpty || isDocEmptyWithSpace) {
            const aiChatElement = document.querySelector('.ai_chat_plugin_main');
            console.info('======>check isAiWriteActive:', aiChatElement); // 调试信息
            if (aiChatElement) {
                isDocEmpty = false;
                isDocEmptyWithSpace = false;
            }
        }
        store.setIsDocEmpty(!!isDocEmpty);
        store.setIsDocEmptyWithSpace(!!isDocEmptyWithSpace);
    }, 200);


    /**
     * 实时同步文档空状态信息
     */
    const setIsDocEmpty = (val: boolean) => {
        store.setIsDocEmpty(val);
    };


    /**
     * 在文档渲染完成后，初始化文档是否为空状态
     */
    useEffect(() => {
        eventBus.on(EDITOR_DOM_READY, syncIsDocEmptyDebounce);
        return () => {
            eventBus.off(EDITOR_DOM_READY, syncIsDocEmptyDebounce);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        return () => {
            setIsDocEmpty(false);
        };
    }, [docGuid, mode]);


    return {
        syncIsDocEmptyDebounce,
        setIsDocEmpty,
    };
};
